import { QuizFormFields } from '@/components/question/forms/quiz/QuizForm';
import { quizQuestionGenerator } from '@/data/generators/quizQuestionGenerator';
import {
  QuizAnswer,
  QuizAnswerCreateDTO,
  QuizAnswerTypeEnum,
} from '@/models/Answer';
import { QuestionTypeEnum, QuizQuestion } from '@/models/Question';
import { normalizeTranslatableField } from '@/utils/translatable-field/normalizeTranslatableField';

export type MediaUrlResolver = (
  mediaFile: QuizAnswerCreateDTO['mediaFile'],
) => string | null;

export const resolveStringMedia: MediaUrlResolver = mediaFile =>
  typeof mediaFile === 'string' ? mediaFile : null;

export default function adapterQuizForm(
  quiz: QuizFormFields,
  resolveMediaUrl: MediaUrlResolver = resolveStringMedia,
): QuizQuestion {
  const quizAnswers = adapterQuizAnswers(
    quiz.quizAnswers ?? [],
    resolveMediaUrl,
  );
  const hasMedia = quizAnswers.some(answer => answer.mediaLink);

  return quizQuestionGenerator({
    title: normalizeTranslatableField(quiz.title),
    context: normalizeTranslatableField(quiz.context),
    type: QuestionTypeEnum.QUIZ,
    answerType: hasMedia ? QuizAnswerTypeEnum.IMAGE : QuizAnswerTypeEnum.TEXT,
    quizAnswers,
  });
}

const adapterQuizAnswers = (
  answers: QuizAnswerCreateDTO[],
  resolveMediaUrl: MediaUrlResolver,
): QuizAnswer[] =>
  answers.map(({ mediaFile, ...answer }, index) => ({
    ...answer,
    id: answer.id ?? index,
    mediaFile: null,
    mediaLink: resolveMediaUrl(mediaFile) ?? answer.mediaLink,
  }));
